"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateAttAppleCampaignNamesResponseSchema = exports.UpdateAttAppleCampaignNamesBodySchema = exports.ListAttAppleCampaignNamesQuerySchema = exports.ListAttAppleCampaignNamesResponseSchema = exports.UpdateAppleTodayTabRegionBodySchema = exports.CreateAppleTodayTabRegionBodySchema = exports.ListAppleTodayTabRegionResponseSchema = exports.GetAppleTodayTabRegionQuerySchema = exports.UpdateAppleTodayTabRegionResponseSchema = exports.CreateAppleTodayTabRegionResponseSchema = exports.GetAppleTodayTabRegionResponseSchema = exports.AppleTodayTabRegionResponseSchema = exports.AppleTodayTabRegionFields = exports.ListAppleTodayTabChannelResponseSchema = exports.ListAppleTodayTabChannelQuerySchema = exports.UpdateAppleTodayTabChannelResponseSchema = exports.CreateAppleTodayTabChannelResponseSchema = exports.GetAppleTodayTabChannelResponseSchema = exports.AppleTodayTabChannelResponseSchema = exports.AppleTodayTabChannelFields = exports.UpdateAppleTodayTabChannelBodySchema = exports.CreateAppleTodayTabChannelBodySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("./common");
/**
 * Channel API Types
 */
exports.CreateAppleTodayTabChannelBodySchema = (0, core_1.StrictObject)({
    ...common_1.CreateAppleChannelFields,
});
exports.UpdateAppleTodayTabChannelBodySchema = (0, core_1.StrictObject)({
    ...common_1.UpdateAppleChannelFields,
});
exports.AppleTodayTabChannelFields = {
    ...common_1.AppleChannelIdFields,
    ...core_1.ModelMetaFields,
    ...common_1.CreateAppleChannelFields,
    structure: ruby_1.ChannelStructureSchema,
};
exports.AppleTodayTabChannelResponseSchema = (0, core_1.StrictObject)(exports.AppleTodayTabChannelFields);
exports.GetAppleTodayTabChannelResponseSchema = exports.AppleTodayTabChannelResponseSchema;
exports.CreateAppleTodayTabChannelResponseSchema = exports.AppleTodayTabChannelResponseSchema;
exports.UpdateAppleTodayTabChannelResponseSchema = exports.AppleTodayTabChannelResponseSchema;
exports.ListAppleTodayTabChannelQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    status: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleChannelStatusSchema)),
});
exports.ListAppleTodayTabChannelResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleTodayTabChannelResponseSchema);
/**
 * Channel region API Types
 */
exports.AppleTodayTabRegionFields = {
    ...core_1.ModelMetaFields,
    budgetWeighting: core_1.WeightingSchema,
    defaultBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    status: ruby_1.AppleChannelRegionStatusSchema,
    country: core_1.CountrySchema,
    cpdGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    apple: typebox_1.Type.Optional((0, core_1.StrictObject)({
        orgRef: ruby_1.AppleProxyOrgRefSchema,
        campaignRef: ruby_1.AppleProxyRefSchema,
    })),
};
exports.AppleTodayTabRegionResponseSchema = (0, core_1.StrictObject)(exports.AppleTodayTabRegionFields);
exports.GetAppleTodayTabRegionResponseSchema = exports.AppleTodayTabRegionResponseSchema;
exports.CreateAppleTodayTabRegionResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleTodayTabRegionResponseSchema);
exports.UpdateAppleTodayTabRegionResponseSchema = exports.AppleTodayTabRegionResponseSchema;
exports.GetAppleTodayTabRegionQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.ListAppleTodayTabRegionResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleTodayTabRegionResponseSchema);
exports.CreateAppleTodayTabRegionBodySchema = (0, core_1.StrictObject)({
    ...common_1.CreateAppleRegionCommonFields,
});
exports.UpdateAppleTodayTabRegionBodySchema = (0, core_1.StrictObject)({
    ...common_1.UpdateAppleRegionCommonFields,
});
exports.ListAttAppleCampaignNamesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.AppleCampaignNameSchema);
exports.ListAttAppleCampaignNamesQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.UpdateAttAppleCampaignNamesBodySchema = (0, core_1.StrictObject)({
    campaignNames: typebox_1.Type.Array(common_1.UpdateAppleCampaignNameSchema),
});
exports.UpdateAttAppleCampaignNamesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.AppleCampaignNameSchema);
